module.exports = __webpack_public_path__ + "img/yuti.7aec30b3.jpg";